<template>
	<div class="player">
		<div class="icon" :style="{background: this.cor}">
			<div class="avatarP"></div>
			<div class="iconeP"></div>
		</div>
		<div class="boxLoc">
			<span class="locutor">{{this.locutor}}</span><span> com </span><span class="program">{{this.programa}}</span>
		</div>
		<div  class="ouvintes"><span class="ouvNum">{{this.ouvintes}}</span> ouvintes</div>
		<div class="actions">
			<!-- <button><i class="fa-solid fa-angle-left"></i></button> -->
			<button id="play" @click="Play(!this.playing)"><i class="fa-solid fa-pause"></i></button>
			<!-- <button><i class="fa-solid fa-angle-right"></i></button> -->
		</div>
		<div class="time">
			<div class="bar" id="time" style="width: 50%"></div>
		</div>
		<div class="volume" @mouseenter="mouseVol = true">
			<div class="vol" @mouseleave="mouseVol = false" :class="{active: mouseVol}">
				<input type="range" name="volume" id="vol" max="100" min="0" step="1" v-model="volume" @change="rangeVol($event)">
			</div>
			<i class="fa-solid fa-volume-low"></i>
		</div>
		<a :href="this.link" target="_blank" rel="noopener noreferrer"><button class="visit"><i class="fa-solid fa-arrow-up-right-from-square"></i>  Visitar</button></a>
	</div>
</template>

<script>
import {base} from '../../var.js'


export default {
	name: 'PlayerItem',
	components:{
	},
	data() {
		return {
			icon: '',
			cor: '',
			volume: 60,
			value: 30,
			ip: '',
			porta: '',
			ipextra: '',
			box: '',
			locutor: '',
			programa: '',
			ouvintes: 11,
			link: '',
			music: '',
			fsProx: 0,
			fsAnt: 0,
			mouseVol: false,
			playing: true
		}
	},
	mounted() {
		// this.audio(2);
		// this.status(2);
		this.getMin()
		setInterval(() => {this.getMin()}, 5000);
	},
	methods:{
		getMin(){
			var currentHours=new Date();
			var montCurrentHours=currentHours.getMinutes();
			var currentHoursPrint=currentHours.getHours()+":00";
			currentHoursPrint;
			var nextHours=new Date();
			nextHours=new Date(currentHours.setMinutes(59));
			var montNextHours=nextHours.getMinutes();
			var nexthoursPrint=new Date();
			nexthoursPrint=new Date(nexthoursPrint.setMinutes());
			nexthoursPrint=new Date(nexthoursPrint.setHours(nexthoursPrint.getHours()+1));
			nexthoursPrint=nexthoursPrint.getHours()+":00";
			nexthoursPrint;
			var calcSchedule=(montCurrentHours/montNextHours) * 100;
			const time = document.getElementById('time');
			time.setAttribute('style', 'width: '+calcSchedule+'%');
		},
		async audio(id){
			if(id != 0){
				const play  = document.querySelector('.player')
				play.classList.add('active')

				this.Play(true);

				const audio = document.getElementById('audio')
				audio.remove()
				const app = document.getElementById('app');
				const c = document.createElement('div');
				c.getAttribute('id', 'audio')
				app.after(c)
				
				const req = await fetch(base+"dados/"+id);
				const data = await req.json();
				this.ip = data.ip;
				this.porta = data.porta;
				this.ipextra = data.ipextra;
				

				if(this.ipextra == ''){
					this.box = `<audio id="audio" autoplay="" controls src="https://${this.ip}:${this.porta}/stream" style="display: none;">`;
				}else{
					this.box = `<audio id="audio" autoplay="" controls src="http://${this.ipextra}/stream" style="display: none;"></audio>`;
					
				}
				app.insertAdjacentHTML("beforeend", this.box)
				localStorage.setItem('id', id);
				this.status(id);
				this.Volume(0.6);
				setInterval(() => {
					this.status(id);
				}, 10000);
			}
		},
		async status(id){
			const idd = localStorage.getItem('id') ?? '';
			if(id == idd){
				const req = await fetch(base+"status/"+id);
				const data = await req.json();
				
				document.querySelector('.locutor').innerHTML = data.locutor
				document.querySelector('.program').innerHTML = data.programa
				document.querySelector('.ouvNum').innerHTML = data.ouvintes;
				document.querySelector('.icon').setAttribute('style', 'background-color: '+data.cor);
				this.music = data.music;
				document.querySelector('.avatarP').setAttribute('style', 'background-image: url('+data.avatar+')');
				document.querySelector('.iconeP').setAttribute('style', 'background-image: url(uploads/'+data.icon+')');
				document.querySelector('.player a').setAttribute('href', data.link);
			}
		},
		rangeVol(e){
			const ele = e.target;

			let value = ele.value;
			ele.style.background = 'linear-gradient(to right, var(--color1) '+value+'%, var(--color1) ' + value + '%, #ccc 0%, #ccc 100%)'
			ele.setAttribute('value', this.volume)
			
			this.Volume(this.volume/100)
		},
		Play(p){
			const icon = document.querySelector('.fa-solid');
			this.playing = !this.playing;
			if(p == true){
				icon.classList.remove("fa-play");
				icon.classList.add("fa-pause");
				this.Volume(0.6)
			}else{
				icon.classList.remove("fa-pause");
				icon.classList.add("fa-play");
				this.Volume(0)
			}
		},
		Volume(v){
			document.getElementById("audio").volume = v;
		}
	}
}
</script>

<style scoped>
.topheader .player {
	float: left;
	width: 70%;
	height: 100%;
	display: flex;
	justify-content: space-between;
	margin-right: 20px;
	color: #444;
	opacity: 0;
	transition: all .4s ease;
}
.topheader .player.active {opacity: 1;}

.player .icon {
	position: relative;
	width: 50px;
	height: 50px;
	border-radius: 50px;
	margin-top: 14px;
}

.player .icon .avatarP {
	float: left;
	width: 36px;
	height: 46px;
	margin: 4px 0 0 10px;
	background-repeat: no-repeat;
}

.player .icon .iconeP {
	float: left;
	width: 20px;
	height: 20px;
	margin: -12px 0 0 36px;
	background-size: 80%;
	background-repeat: no-repeat;
}

.player .boxLoc {
	position: relative;
	width: auto;
	height: 80%;
	line-height: 20px;
	margin-top: 18px;
	font-size: 11px;
}
.player .boxLoc span:first-of-type {
	width: 100%;
	float: left;
	font-size: 15px;
	font-weight: 600;
}
.player .boxLoc span:last-of-type {font-size: 13px;}

.player .actions {
	display: flex;
	justify-content: space-around;
	width: 140px;
	height: 40px;
	margin-top: 17px;
}

.player .ouvintes {
	width: auto;
	height: 20px;
	line-height: 20px;
	font-size: 13px;
	margin-top: 25px;
}
.player .ouvintes span {
	font-weight: 600;
}

.player .actions button {
	width: 40px;
	height: 100%;
	background-color: transparent;
	font-size: 13px;
}

.player .actions button#play {
	background-color: var(--color1);
	border-radius: 50px;
	color: #fff;
	text-align: center;
	line-height: 42px;
}

.player .time {
	width: 500px;
	height: 4px;
	background-color: rgba(0,0,0,.2);
	border-radius: 4px;
	margin-top: 36px;
}

.player .time .bar {
	height: 100%;
	background-color: var(--color1);
	border-radius: 4px;
}

.player .volume {
	width: 30px;
	height: 30px;
	margin-top: 25px;
	line-height: 30px;
	text-align: center;
	color: #333;
	font-size: 13px;
}

.player .volume .vol {
	position: absolute;
	width: 154px;
	height: 46px;
	background-color: #fff;
	border-radius: 5px;
	border: 1px solid rgba(0,0,0,.2);
	transform: rotateZ(-90deg);
	margin: 84px 0 0 -62px;
	opacity: 0;
	display: none;
	transition: all .3s ease;
	z-index: 99;
}
.player .volume .vol.active {opacity: 1;display: block;}

.player .volume .vol input {
	width: 130px;
	height: 2px;
	margin: 21px 0 0 4px;
	-webkit-appearance: none;
	background-color: #ccc;
	border-radius: 4px;
	background: linear-gradient(to right, var(--color1) 60%, var(--color1) 60%, #ccc 0%, #ccc 100%);
}

.player .volume .vol input::-webkit-slider-thumb {
	-webkit-appearance: none;
	width: 14px;
	height: 14px;
	border-radius: 50%;
	background: #fff;
	cursor: pointer;
	box-shadow: 0 1px 5px rgba(0,0,0,.2)	;
}

.player .visit {
	width: auto;
	height: 40px;
	padding: 0 20px;
	color: #fff;
	font-size: 14px;
	font-weight: 600;
	border-radius: 40px;
	background-color: var(--color1);
	margin-top: 16px;
}
</style>